var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStretch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,13.9208984c-0.4140625,0-0.75,0.3359375-0.75,0.75v2.5185547l-4.1787109-4.1787109 c-0.2929688-0.2929688-0.7675781-0.2929688-1.0605469,0s-0.2929688,0.7675781,0,1.0605469L17.1894531,18.25h-2.5195312 c-0.4140625,0-0.75,0.3359375-0.75,0.75s0.3359375,0.75,0.75,0.75H19c0.4140625,0,0.75-0.3359375,0.75-0.75v-4.3291016 C19.75,14.2568359,19.4140625,13.9208984,19,13.9208984z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8103638,5.75h2.5197144c0.4140625,0,0.75-0.3359375,0.75-0.75s-0.3359375-0.75-0.75-0.75H5 C4.5859375,4.25,4.25,4.5859375,4.25,5v4.3300781c0,0.4140625,0.3359375,0.75,0.75,0.75s0.75-0.3359375,0.75-0.75V6.81073 l4.1787109,4.1795044c0.1464844,0.1464844,0.3378906,0.2197266,0.5302734,0.2197266 c0.1914062,0,0.3837891-0.0732422,0.5302734-0.2197266c0.2929688-0.2929688,0.2929688-0.7675781,0-1.0605469L6.8103638,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,4.25h-4.3300781c-0.4140625,0-0.75,0.3359375-0.75,0.75s0.3359375,0.75,0.75,0.75h2.5205078 l-4.1796875,4.1796875c-0.2929688,0.2929688-0.2929688,0.7675781,0,1.0605469 c0.1464844,0.1464844,0.3378906,0.2197266,0.5302734,0.2197266s0.3837891-0.0732422,0.5302734-0.2197266L18.25,6.8115234v2.5185547 c0,0.4140625,0.3359375,0.75,0.75,0.75s0.75-0.3359375,0.75-0.75V5C19.75,4.5859375,19.4140625,4.25,19,4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.9287109,13.0107422L5.75,17.1902466v-2.5193481c0-0.4140625-0.3359375-0.75-0.75-0.75 s-0.75,0.3359375-0.75,0.75V19c0,0.4140625,0.3359375,0.75,0.75,0.75h4.3300781c0.4140625,0,0.75-0.3359375,0.75-0.75 s-0.3359375-0.75-0.75-0.75H6.8113403l4.1779175-4.1787109c0.2929688-0.2929688,0.2929688-0.7675781,0-1.0605469 S10.2216797,12.7177734,9.9287109,13.0107422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStretch);
export default __webpack_public_path__ + "static/media/Stretch.cc530f8a493ffcc47a7d31a7edd82f17.svg";
export { ForwardRef as ReactComponent };